// ================== Function definitions ==================
 document.addEventListener('keydown', function (event) {
  if (event.key !== 'Escape') return;

  var cartButton = document.querySelector('.js-toggle-cart');
  var cart = document.querySelector('#MiniCartContent');

  if (!cartButton || !cart) return;

  if (cartButton.getAttribute('aria-expanded') === 'true') {
    cartButton.click();
    cartButton.focus();
  }
});
// 
 document.addEventListener('focusout', function (event) {
  setTimeout(function () {
    var cartButton = document.querySelector('.js-toggle-cart');
    var cartContents = document.querySelectorAll('.mini-cart-content');
    var activeElement = document.activeElement;

    if (!cartButton) return;

    var insideCart = activeElement === cartButton;

    cartContents.forEach(function (cart) {
      if (cart.contains(activeElement)) {
        insideCart = true;
      }
    });

    if (!insideCart && cartButton.getAttribute('aria-expanded') === 'true') {
      cartButton.click();
    }
  }, 50);
});
// Fix accessibility issues with Roeye tracking pixels
function fixRoeyeTrackingPixels() {
  function fixRoeyeTrackingPixel(img) {
    if (!img || (img.getAttribute("alt") === "" && img.getAttribute("aria-hidden") === "true")) {
      return;
    }
    img.setAttribute("alt", "");
    img.setAttribute("aria-hidden", "true");
    img.setAttribute("role", "presentation");
  }

  function findRoeyeImages() {
    return Array.from(
      document.querySelectorAll('img[src*="lantern.roeye.com"], img[src*="lantern.roeyecdn.com"]')
    );
  }

  var observer = new MutationObserver(function (mutations, obs) {
    var images = findRoeyeImages();
    if (!images.length) return;

    images.forEach(fixRoeyeTrackingPixel);
    obs.disconnect();
  });

  var roeyeImages = findRoeyeImages();
  if (roeyeImages.length) {
    roeyeImages.forEach(fixRoeyeTrackingPixel);
  }

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["src", "alt", "aria-hidden", "role"]
  });

  setTimeout(function () {
    observer.disconnect();
  }, 5000);
}

// Fix broken Slick slider aria-describedby references
function fixBrokenSlickAriaReferences() {
  document.querySelectorAll('.slick-slide[aria-describedby]').forEach(function (slide) {
    var refId = slide.getAttribute('aria-describedby');
    if (refId && !document.getElementById(refId)) {
      slide.removeAttribute('aria-describedby');
    }
  });
}

function initSlickAriaFix() {
  fixBrokenSlickAriaReferences();
  setTimeout(fixBrokenSlickAriaReferences, 500);
  setTimeout(fixBrokenSlickAriaReferences, 1500);
  setTimeout(fixBrokenSlickAriaReferences, 3000);
}

// Fix accessibility issues with custom collapse toggles
function initCustomCollapseToggles() {
  document.querySelectorAll(".js-custom-collapse-toggle").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var targetId = btn.getAttribute("aria-controls");
      var target = document.getElementById(targetId);
      if (!target) return;

      var isOpen = btn.getAttribute("aria-expanded") === "true";

      btn.setAttribute("aria-expanded", isOpen ? "false" : "true");
      target.classList.toggle("is-open", !isOpen);
    });
  });
}

// Fix accessibility issues with cart modal dialog
// Fix accessibility issues with cart toggle button
function initCartToggleButtonA11y() {
  const cartBtn = document.querySelector(".js-toggle-cart");
  const miniCart = document.querySelector("#MiniCartContent");
  const cartWrapper = document.querySelector(".js-mini-cart");
  const cartCount = document.querySelector(".js-cart-count");

  if (!cartBtn || !miniCart) return;

  function updateCartButtonState(isOpen) {
    cartBtn.setAttribute("aria-expanded", isOpen ? "true" : "false");

    const count = cartCount
      ? cartCount.textContent.trim()
      : "0";

    cartBtn.setAttribute(
      "aria-label",
      isOpen
        ? "Close cart"
        : `Cart, ${count} ${count === "1" ? "item" : "items"}`
    );
  }

  cartBtn.addEventListener("click", function () {
    const isOpen = miniCart.classList.toggle("active");

    if (cartWrapper) {
      cartWrapper.classList.toggle("active", isOpen);
    }

    updateCartButtonState(isOpen);
  });

  document.addEventListener("click", function (e) {
    const closeBtn = e.target.closest(".js-close-cart");

    if (!closeBtn) return;

    e.preventDefault();

    miniCart.classList.remove("active");

    if (cartWrapper) {
      cartWrapper.classList.remove("active");
    }

    updateCartButtonState(false);
  });
}

// Fix accessibility issues with product description headings
function fixProductDescriptionHeadings() {
  if (!window.location.pathname.includes("/products/")) return;

  document
    .querySelectorAll(".product-description-a11y h4, #nav-tab-info .tab-pane h4")
    .forEach(function (h4) {
      if (!h4.textContent.trim() || h4.textContent.trim() === "\u00a0") return;

      var h2 = document.createElement("h2");
      h2.innerHTML = h4.innerHTML;
      h2.className = "product-desc-heading-a11y";

      h4.replaceWith(h2);
    });
}

// Fix accessibility issues with external links
function initExternalLinksA11y() {
  /*
    Leave empty [] to run on all pages.
    Or add specific paths like ['/ruth', '/ciara', '/contact']
  */
  var allowedPages = [];

  var externalWarning = 'Redirecting to a third-party website (opens in a new tab)';

  function normalizePath(path) {
    return (path || '/').toLowerCase().replace(/\/$/, '') || '/';
  }

  function shouldRunOnThisPage() {
    if (!allowedPages.length) return true;

    var currentPath = normalizePath(window.location.pathname);

    return allowedPages.some(function (page) {
      return normalizePath(page) === currentPath;
    });
  }

  function getElementText(el) {
    if (!el) return '';

    return (el.innerText || el.textContent || '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isExternalLink(link) {
    var href = link.getAttribute('href');

    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:') ||
      href.startsWith('javascript:')
    ) {
      return false;
    }

    try {
      var url = new URL(href, window.location.href);
      return url.hostname !== window.location.hostname;
    } catch (e) {
      return false;
    }
  }

  function getImageLinkName(link) {
    var existingLabel = link.getAttribute('aria-label');

    if (
      existingLabel &&
      existingLabel.trim() !== '' &&
      !/third-party website|opens in a new tab|redirecting/i.test(existingLabel)
    ) {
      return existingLabel.replace(/\s+/g, ' ').trim();
    }

    var linkText = getElementText(link);
    if (linkText) return linkText;

    var img = link.querySelector('img');

    if (img) {
      var imgAlt = img.getAttribute('alt');
      if (imgAlt && imgAlt.trim() !== '') {
        return imgAlt.replace(/\s+/g, ' ').trim();
      }

      var imgAriaLabel = img.getAttribute('aria-label');
      if (imgAriaLabel && imgAriaLabel.trim() !== '') {
        return imgAriaLabel.replace(/\s+/g, ' ').trim();
      }

      var imgTitle = img.getAttribute('title');
      if (imgTitle && imgTitle.trim() !== '') {
        return imgTitle.replace(/\s+/g, ' ').trim();
      }
    }

    var linkTitle = link.getAttribute('title');
    if (linkTitle && linkTitle.trim() !== '') {
      return linkTitle.replace(/\s+/g, ' ').trim();
    }

    return 'External link';
  }

  function fixThirdPartyLinks() {
    if (!shouldRunOnThisPage()) return;

    document.querySelectorAll('a[href]').forEach(function (link) {
      if (!isExternalLink(link)) return;

      var currentLabel = link.getAttribute('aria-label') || '';

      if (/third-party website|opens in a new tab|redirecting/i.test(currentLabel)) {
        return;
      }

      var linkName = getImageLinkName(link);

      link.setAttribute(
        'aria-label',
        linkName + ', ' + externalWarning
      );

      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  }

  fixThirdPartyLinks();
  setTimeout(fixThirdPartyLinks, 800);
  setTimeout(fixThirdPartyLinks, 2000);
  window.addEventListener('load', fixThirdPartyLinks);
}

// Fix accessibility issues with empty headings
function removeEmptyHeadings() {
  if (
    location.search.includes('editing=true') ||
    location.search.includes('preview=true') ||
    document.body.classList.contains('sqs-edit-mode') ||
    document.body.classList.contains('sqs-editing')
  ) {
    return;
  }

  document.querySelectorAll('h1,h2,h3,h4,h5,h6').forEach(function (heading) {
    if (
      heading.children.length === 0 &&
      heading.textContent.replace(/\u00A0/g, '').trim() === ''
    ) {
      heading.remove();
    }
  });
}

function initEmptyHeadingsFix() {
  // Run after Squarespace finishes rendering
  setTimeout(removeEmptyHeadings, 1000);
}

// Fix accessibility issues with hidden product thumbnails
function fixHiddenProductThumbnails() {
  document.querySelectorAll('[aria-hidden="true"] .product-single__thumbnail').forEach(function (btn) {
    btn.setAttribute('tabindex', '-1');
  });

  document.querySelectorAll('[aria-hidden="false"] .product-single__thumbnail, .product-single__thumbnail').forEach(function (btn) {
    if (!btn.closest('[aria-hidden="true"]')) {
      btn.removeAttribute('tabindex');
    }
  });
}

function initHiddenProductThumbnailsFix() {
  setTimeout(fixHiddenProductThumbnails, 800);
}

// Fix accessibility issues with drawer focus
function initDrawerFocus() {
  const openBtn = document.querySelector('.js-drawer-open-left');
  const drawer = document.getElementById('NavDrawer');

  if (!openBtn || !drawer) return;

  openBtn.addEventListener('click', function () {
    setTimeout(function () {
      const closeBtn = drawer.querySelector('.js-drawer-close');
      if (closeBtn) {
        closeBtn.focus();
      }
    }, 250); // adjust if your drawer animation is longer
  });
}

// Fix accessibility issues with search focus
function initSearchFocusA11y() {
  document.addEventListener("keydown", function (e) {
    const search = document.getElementById("form-search-header");
    if (!search || !search.classList.contains("active")) return;

    if (e.key === "Escape") {
      e.preventDefault();
      toggleClassSearch();
      return;
    }

    if (e.key !== "Tab") return;

    const focusable = getSearchFocusable(search);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });
}

// Fix accessibility issues with sidebar focus
function initSidebarFocus() {
  const openBtn = document.getElementById("sidebarCollapse");
  const sidebar = document.getElementById("sidebar");
  const closeBtn = document.getElementById("dismiss");
  const overlay = document.querySelector(".overlaysidebar");

  if (!openBtn || !sidebar || !closeBtn) return;

  function openSidebar() {
    sidebar.classList.add("active");
    sidebar.removeAttribute("inert");
    sidebar.setAttribute("aria-hidden", "false");
    openBtn.setAttribute("aria-expanded", "true");

    if (overlay) overlay.classList.add("active");

    setTimeout(function () {
      closeBtn.focus();
    }, 100);
  }

  function closeSidebar() {
    sidebar.classList.remove("active");
    sidebar.setAttribute("aria-hidden", "true");
    sidebar.setAttribute("inert", "");
    openBtn.setAttribute("aria-expanded", "false");

    if (overlay) overlay.classList.remove("active");

    openBtn.focus();
  }

  openBtn.addEventListener("click", function (e) {
    e.preventDefault();
    openSidebar();
  });

  closeBtn.addEventListener("click", function (e) {
    e.preventDefault();
    closeSidebar();
  });

  if (overlay) {
    overlay.addEventListener("click", closeSidebar);
  }

  document.addEventListener("keydown", function (e) {
    if (!sidebar.classList.contains("active")) return;

    if (e.key === "Escape") {
      e.preventDefault();
      closeSidebar();
    }
  });
}

// Fix accessibility issues with cart toggle button
function initCartToggleButtonA11y() {
  const cartBtn = document.querySelector(".js-toggle-cart");
  const miniCart = document.querySelector(".js-mini-cart");
  const cartCount = document.querySelector(".js-cart-count");

  if (!cartBtn || !miniCart) return;

  function updateCartButtonState(isOpen) {
    cartBtn.setAttribute("aria-expanded", isOpen ? "true" : "false");
    cartBtn.setAttribute(
      "aria-label",
      isOpen ? "Close cart" : "Cart, " + (cartCount ? cartCount.textContent.trim() : "0") + " items"
    );
  }

  cartBtn.addEventListener("click", function () {
    const isOpen = miniCart.classList.toggle("active");
    updateCartButtonState(isOpen);
  });

  document.addEventListener("click", function (e) {
    const closeBtn = e.target.closest(".js-close-cart");
    if (!closeBtn) return;

    e.preventDefault();
    miniCart.classList.remove("active");
    updateCartButtonState(false);
  });
}

// Hide decorative horizontal rules from screen readers
function hideDecorativeHr() {
  document.querySelectorAll("hr").forEach(function (hr) {
    hr.setAttribute("aria-hidden", "true");
    hr.setAttribute("role", "presentation");
  });
}

function initDecorativeHrFix() {
  hideDecorativeHr();
  // In case HRs are added dynamically
  setTimeout(hideDecorativeHr, 500);
  setTimeout(hideDecorativeHr, 1500);
  setTimeout(hideDecorativeHr, 3000);
}

// Fix accessibility issues with complex image description toggles
function initComplexImageToggleA11y() {
  document.querySelectorAll(".ecb-a11y-complex-img-toggle").forEach(function (button) {
    button.addEventListener("click", function () {
      var panelId = button.getAttribute("aria-controls");
      var panel = document.getElementById(panelId);

      if (!panel) return;

      var isExpanded = button.getAttribute("aria-expanded") === "true";

      button.setAttribute("aria-expanded", isExpanded ? "false" : "true");
      panel.hidden = isExpanded;
    });
  });
}

// Focus on customer register form errors after page load
function focusRegisterFormErrors() {
  setTimeout(function () {
    var errors = document.getElementById('RegisterFormErrors');
    if (errors) errors.focus();
  }, 300);
}

// Focus on customer login form errors after page load
function focusCustomerLoginErrors() {
  setTimeout(function () {
    var errors = document.getElementById('CustomerLoginErrors');
    if (errors) errors.focus();
  }, 300);
}

// Move focus into the login dialog when the sign-in trigger is used
function initLoginModalFocus() {
  var loginModal = document.getElementById('jsLogin');
  var loginTriggers = document.querySelectorAll('.js-open-login');

  if (!loginModal || !loginTriggers.length) return;

  var focusFirstLoginControl = function () {
    var preferred = loginModal.querySelector('#CustomerEmail');
    var focusable = preferred || loginModal.querySelector("input:not([type='hidden']), button:not([disabled]), select, textarea, [href], [tabindex]:not([tabindex='-1'])");

    if (!focusable) {
      loginModal.setAttribute('tabindex', '-1');
      loginModal.focus();
      return;
    }

    focusable.focus();
  };

  loginTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      window.setTimeout(focusFirstLoginControl, 180);
    });
  });

  $(loginModal).on('shown.bs.modal', function () {
    window.setTimeout(focusFirstLoginControl, 80);
  });
}

// Convert parent nav links into accessible buttons + dropdown toggle
function initNavDropdownA11y() {
  document.querySelectorAll('.nav-bar ul.site-nav li.site-nav__item-normal > a')
    .forEach(link => {
      link.removeAttribute('href');
      link.setAttribute('role', 'button');
      link.setAttribute('tabindex', '0');
      link.setAttribute('aria-expanded', 'false');
    });

  function toggleMenu(item) {
    const dropdown = item.querySelector('a');

    if (dropdown.getAttribute('aria-expanded') === 'false') {
      document.querySelectorAll('li.site-nav__item-normal > a')
        .forEach(link => link.setAttribute('aria-expanded', 'false'));

      document.querySelectorAll('li.site-nav__item-normal')
        .forEach(li => li.classList.remove('active'));

      dropdown.setAttribute('aria-expanded', 'true');
      item.classList.add('active');
    } else {
      dropdown.setAttribute('aria-expanded', 'false');
      item.classList.remove('active');
    }
  }

  document.querySelectorAll('.nav-bar ul.site-nav li.site-nav__item-normal')
    .forEach(item => {
      item.addEventListener('click', function (e) {
        e.stopPropagation();
        toggleMenu(this);
      });

      item.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter') return;

        e.preventDefault();
        e.stopPropagation();
        toggleMenu(this);
      });
    });

  // Store last focused trigger
  let lastFocusedMenuTrigger = null;

  document.querySelectorAll('li.site-nav__item-normal > a')
    .forEach(link => {
      link.addEventListener('click', function () {
        lastFocusedMenuTrigger = this;
      });
    });

  // Close menu with Escape
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;

    document.querySelectorAll('li.site-nav__item-normal > a')
      .forEach(link => link.setAttribute('aria-expanded', 'false'));

    document.querySelectorAll('li.site-nav__item-normal')
      .forEach(li => li.classList.remove('active'));

    if (lastFocusedMenuTrigger) {
      lastFocusedMenuTrigger.focus();
    }
  });
}

// Fix accessibility issues with product benefits toggle
function initProductBenefitsToggleA11y() {
  var toggle = document.querySelector(
    '.ai-product-hero-collapsible-icon-{{ ai_gen_id }}[data-icon="benefits"]'
  );

  var content = document.querySelector(
    '#benefits-content-{{ ai_gen_id }}'
  );

  if (!toggle || !content) return;

  function toggleBenefits() {
    var isExpanded = toggle.getAttribute("aria-expanded") === "true";
    var nextState = !isExpanded;

    toggle.setAttribute("aria-expanded", String(nextState));
    toggle.classList.toggle("active", nextState);
    content.classList.toggle("active", nextState);
    content.hidden = !nextState;
  }

  toggle.addEventListener("click", toggleBenefits);

  toggle.addEventListener("keydown", function (event) {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      toggleBenefits();
    }
  });
}

// Fix tabindex on hidden cloned slideshow slide links
function updateHiddenClonedSlideLinks() {
  document
    .querySelectorAll('.slideshow__slide.slick-slide[aria-hidden="true"] a')
    .forEach(function (link) {
      link.setAttribute('tabindex', '-1');
    });

  document
    .querySelectorAll('.slideshow__slide.slick-slide[aria-hidden="false"] a')
    .forEach(function (link) {
      link.removeAttribute('tabindex');
    });
}

function initHiddenClonedSlideLinksFix() {
  setTimeout(updateHiddenClonedSlideLinks, 500);
}

// Announce loaded product gallery thumbnail image
function initProductGalleryThumbnailAnnounce() {
  document
    .querySelectorAll('[data-product-gallery-thumbnails]')
    .forEach(function (gallery) {
      const section = gallery.closest('.photos__item--thumbs');
      const status = section?.querySelector('[role="status"]');

      if (!status) return;

      gallery.addEventListener('click', function (event) {
        const button = event.target.closest(
          '.product-single__thumbnail'
        );

        if (!button || !gallery.contains(button)) return;

        const imageNumber =
          button.getAttribute('data-image-number') || '';

        const image = button.querySelector('img');
        const imageAlt = image?.getAttribute('alt')?.trim();

        status.textContent = '';

        setTimeout(function () {
          status.textContent = imageAlt
            ? 'Product image ' +
              imageNumber +
              ', ' +
              imageAlt +
              ', loaded in the gallery.'
            : 'Product image ' +
              imageNumber +
              ' loaded in the gallery.';
        }, 50);
      });
    });
}

 

 
// Label swatch cards with variant name + image alt
function labelSwatchCards() {
  document.querySelectorAll('.js-swatch-card-item').forEach(function (swatch) {
    const variantName = swatch.getAttribute('data-original-title') || '';
    const image = swatch.querySelector('img');
    const imageAlt = image ? image.getAttribute('alt') || '' : '';

    if (variantName && imageAlt) {
      swatch.setAttribute('aria-label', variantName + ' ' + imageAlt);
    }
  });
}
 
document.addEventListener('DOMContentLoaded', function() {
    var backToTopButton = document.getElementById('back-to-top');
    backToTopButton.onclick = function(e) {
        e.preventDefault();
        window.setTimeout(function() {
            document.getElementById('backtoheader').focus(); 
        }, 600);
    };
  });

// ================== Single DOMContentLoaded: just calls ==================

document.addEventListener("DOMContentLoaded", function () {
  fixRoeyeTrackingPixels();
  initSlickAriaFix();
  initCustomCollapseToggles();
  // initCartModalA11y();
  fixProductDescriptionHeadings();
  initExternalLinksA11y();
  initEmptyHeadingsFix();
  initHiddenProductThumbnailsFix();
  initDrawerFocus();
  initSearchFocusA11y();
  initSidebarFocus();
  initCartToggleButtonA11y();
  initDecorativeHrFix();
  initComplexImageToggleA11y();
  focusRegisterFormErrors();
  focusCustomerLoginErrors();
  initLoginModalFocus();
  initNavDropdownA11y();
  initProductBenefitsToggleA11y();
  initHiddenClonedSlideLinksFix();
  initProductGalleryThumbnailAnnounce();
   labelSwatchCards();
  });